import script from "./SaleOrdersReport.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleOrdersReport.vue?vue&type=script&setup=true&lang=js"

import "./SaleOrdersReport.vue?vue&type=style&index=0&id=7ce672fe&lang=css"

const __exports__ = script;

export default __exports__